import { bindActionCreators, compose } from 'redux';
import { TealiumParams, trackPageView } from '@is24at/react-tracking';
import { withTealium, withTracking } from '@is24at/react-tracking/redux';
import { asyncConnect } from 'core/reduxAsync';
import { type AsyncItem } from 'core/reduxAsync/types';
import { byBaseUrl, byImageResizeUrl } from 'core/runtimeConfigReducer';
import fetchRealtorsAndGenerateHtmlMeta from '../../modules/resultListAsyncProps';
import ResultListView from '../ResultListView';

const mapStateToProps = (state: any) => ({
  baseUrl: byBaseUrl(state),
  hits: state.resultList.hits,
  totalHits: state.resultList.totalHits,
  totalPages: state.resultList.totalPages,
  imageResizeUrl: byImageResizeUrl(state),
});

const mapDispatchToProps = (dispatch: any) => {
  const Actions = bindActionCreators(
    {
      trackPageView,
    },
    dispatch,
  );
  return {
    trackingFn: () =>
      Actions.trackPageView({
        [TealiumParams.PAGE_TITLE]: 'is24.at.anbieter.result',
      }),
  };
};

const asyncProps = {
  key: 'pageData',
  promise: fetchRealtorsAndGenerateHtmlMeta,
} satisfies AsyncItem;

const RealtorListContainer = compose(
  asyncConnect(asyncProps, mapStateToProps, mapDispatchToProps),
  withTealium,
  withTracking(),
)(ResultListView);

export default RealtorListContainer;
